export default "__VITE_ASSET__8e3e55cf__"